// import App from './App.vue'
import Login from './components/sections/auth/Login'
import ResetPasswordReq from './components/sections/auth/ResetPasswordReq'
import UpdatePassword from './components/sections/auth/UpdatePassword'
import ReservationsIndex from './components/sections/reservations/Index'
import CoordinationIndex from './components/sections/reservations/Coordination'
import OperationIndex from './components/sections/reservations/Operation'
import UsersIndex from './components/sections/users/Index'
import DestinationsIndex from './components/sections/destinations/Index'
import SalesChannelsIndex from './components/sections/sales-channels/Index'
import SalesChannelContactsIndex from './components/sections/sales-channel-contacts/Index'
import SalesChannelsPrices from './components/sections/sales-channel-prices/index'
import SuppliersIndex from './components/sections/suppliers/Index'
import ServiceTypesIndex from './components/sections/service-types/Index'
import ServiceCategoriesIndex from './components/sections/service-categories/Index'
import PlacesIndex from './components/sections/places/Index'
import PlacesAirport from './components/sections/places/Airport'
import ProfileIndex from './components/sections/profile/Index'
import ChangeLogsIndex from './components/sections/change-logs/Index'
import RatePlansIndex from './components/sections/rate-plans/Index'
import RatePlansEdit from './components/sections/rate-plans/Edit'
import RatePlansCalendar from './components/sections/point-of-sales/prices-calendar/Calendar'
import ZonedAreasIndex from './components/sections/zoned-areas/Index'
import ZonedAreasEdit from './components/sections/zoned-areas/Edit'
import PointOfSalesIndex from './components/sections/point-of-sales/Index'
import ReportsIndex from './components/sections/reports/Index'
import DashboardIndex from './components/sections/dashboard/Index'
import SupplierPrices from './components/sections/rates/SupplierPrices'
import OperationLive from './components/sections/live-operation/Single.vue'
import QuoteFlights from './components/sections/quote-flights/Single.vue'
import ReasonStates from './components/sections/reason-states/Index.vue'
import AdditionalServicesCrud from './components/sections/additional-services/Index.vue'
import LockSales from './components/sections/locks-sales/index.vue'
import Profiles from './components/sections/profiles/Index'
import Home from './components/sections/layout/Home.vue'
import Mapping from './components/sections/mapping/index.vue'
import ImportBookings from './components/sections/import-bookings/index.vue'
import ImportReviews from './components/sections/reviews/index.vue'
import MeetingInstructions from './components/sections/meeting-instructions/Index'
import SalesChannelRules from './components/sections/sales-channel-rules/Index'
import ServerStatus from './components/sections/dashboard/ServerStatus'
import AllotmentMain from './components/sections/allotment/Main'
import EventsSubscriptions from './components/sections/events-subscriptions/Index'

export default {
  '/': ReservationsIndex,
  '/home': Home,
  '/reason-states': ReasonStates,
  '/lock-sales': LockSales,
  '/operation': OperationIndex,
  '/login': Login,
  '/coordination':CoordinationIndex,
  '/reset-passwd': ResetPasswordReq,
  '/update-passwd': UpdatePassword,
  '/reservations': ReservationsIndex,
  '/users': UsersIndex,
  '/destinations': DestinationsIndex,
  '/sales-channels': SalesChannelsIndex,
  '/sales-channel-contacts': SalesChannelContactsIndex,
  '/sales-channels/prices': SalesChannelsPrices,
  '/suppliers': SuppliersIndex,
  '/service-types': ServiceTypesIndex,
  '/service-categories': ServiceCategoriesIndex,
  '/places': PlacesIndex,
  '/airport': PlacesAirport,
  '/profile': ProfileIndex,
  '/change-logs': ChangeLogsIndex,
  '/rate-plans': RatePlansIndex,
  '/rate-plans-edit': RatePlansEdit,
  '/rate-plans/calendar': RatePlansCalendar,
  '/zoned-areas': ZonedAreasIndex,
  '/zoned-areas-edit': ZonedAreasEdit,
  '/point-of-sales': PointOfSalesIndex,
  '/reports': ReportsIndex,
  '/dashboard': DashboardIndex,
  '/suppliers/prices': SupplierPrices,
  '/operation/live': OperationLive,
  '/quote/flights': QuoteFlights,
  '/additional-services':AdditionalServicesCrud,
  '/profiles': Profiles,
  '/mapping': Mapping,
  '/imports': ImportBookings,
  '/reviews/imports': ImportReviews,
  '/meeting-instructions': MeetingInstructions,
  '/sales-channels/rules': SalesChannelRules,
  '/status':ServerStatus,
  '/allotment':AllotmentMain,
  '/event-subscriptions' : EventsSubscriptions
}
